import React from "react";
import { useIntl } from "react-intl";
import { StoreLayout } from "components/store-layout/StoreLayout";
import { StorePageHeader } from "toolkit/pageHeader/StorePageHeader";
import { NewSubscriptionRoutes } from "pages/store/subscription/new/NewSubscriptionRoutes";

import { StoreBreadcrumb } from "toolkit/breadcrumb/StoreBreadcrumb";

import "./NewSubscription.less";

export function NewSubscription() {
  const intl = useIntl();

  const routes = [
    {
      path: "/store",
      breadcrumbName: intl.formatMessage({ id: "jmix-store.header.store" }),
    },
    {
      path: "/",
      breadcrumbName: "",
    },
  ];

  return (
    <>
      <StorePageHeader
        title={intl.formatMessage({ id: "jmix-store.new-subscription.title" })}
        breadcrumb={<StoreBreadcrumb routes={routes} />}
        className="store__page-header"
      />
      <StoreLayout>
        <NewSubscriptionRoutes />
      </StoreLayout>
    </>
  );
}
